// extracted by mini-css-extract-plugin
export default {"btn_minus":"Counter_btn_minus__k7F+Y","btn_plus":"Counter_btn_plus__uxN8E","counter_value":"Counter_counter_value__GJINA","icons":"Counter_icons__IRrvw"};